import SeoHead from './SeoHead';
import { Breadcrumbs, Button } from './ComponentLibrary';
import { pageMeta } from '../seoUtils';
import { useCookieConsent } from '../context/CookieConsentContext';

function CookiePolicyPage() {
  const { openSettings } = useCookieConsent();
  const seo = pageMeta({
    title: 'Cookie Policy',
    description:
      'Learn which cookies NaijaNest uses, what each category does, and how to change your preferences.',
    path: '/cookie-policy',
  });

  return (
    <div className="static-page cookie-policy-page">
      <SeoHead title={seo.fullTitle} description={seo.desc} url={seo.url} image={seo.img} />
      <Breadcrumbs
        items={[
          { label: 'Home', href: '/' },
          { label: 'Cookie Policy', current: true },
        ]}
      />
      <section className="section">
        <header className="cookie-policy-page__intro">
          <h1>Cookie Policy</h1>
          <p className="static-page__lead">Last updated: July 2026</p>
        </header>

        <p>
          Cookies are small files a site stores in your browser. We group ours into four
          categories, and you decide which ones (beyond the essential ones) NaijaNest can use.
          You can change your choice anytime using the &ldquo;Cookie Settings&rdquo; link in the
          footer.
        </p>

        <Button variant="secondary" onClick={openSettings}>
          Manage Cookie Preferences
        </Button>

        <h2>Essential</h2>
        <p>
          Required for the site to work: keeping you signed in, remembering security tokens, and
          protecting against fraud. These can&rsquo;t be switched off, because the site can&rsquo;t
          function without them.
        </p>
        <ul>
          <li>Session and authentication cookies</li>
          <li>
            Google&rsquo;s sign-in script, only on the login/sign-up pages where the &ldquo;Sign in
            with Google&rdquo; button is offered as an alternative to email/password - it
            doesn&rsquo;t load anywhere else on the site
          </li>
        </ul>

        <h2>Functional</h2>
        <p>Remembers your preferences and enables a couple of convenience features.</p>
        <ul>
          <li>Your light/dark theme preference</li>
          <li>The Google One Tap prompt (the small account chooser offered to signed-out visitors)</li>
        </ul>

        <h2>Analytics</h2>
        <p>Helps us understand how the site is used, so we can improve it.</p>
        <ul>
          <li>Google Analytics</li>
          <li>Firebase Analytics</li>
        </ul>

        <h2>Marketing</h2>
        <p>
          Reserved for ad and campaign cookies. Nothing uses this category today; if that changes,
          we&rsquo;ll list the scripts here before they run.
        </p>

        <h2>Your choice, honoured immediately</h2>
        <p>
          Nothing in the Analytics or Marketing categories loads before you consent. Turning a
          category off (including from the footer&rsquo;s &ldquo;Cookie Settings&rdquo; link)
          stops the related scripts right away and removes any analytics cookies already set, no
          reload required.
        </p>
        <p>
          Your choice is remembered for about 6 months, after which we&rsquo;ll ask again - so a
          decision you made a long time ago doesn&rsquo;t stay in effect forever without you
          revisiting it.
        </p>

        <p>
          Questions? Email{' '}
          <a href="mailto:hello@naijanestproperties.com">hello@naijanestproperties.com</a>.
        </p>
      </section>
    </div>
  );
}

export default CookiePolicyPage;
